import { getCookies } from '@hyphengroup/cms-components/utils/cookies';
import { CustomerProfileQueryOperation } from '__generated__/graphql';
import { Dispatch, Dispatcher, useDispatcher } from 'utils/dispatcher';
import { parseIdentityToken } from '$/modules/auth/shared';
import { fetchClientOperation } from '$/modules/graphql-client/fetchClientOperation';

export type Profile = {
  readonly loggedIn: boolean;
  readonly customer?: {
    readonly firstName: string | undefined;
    readonly email: string | undefined;
    readonly phoneNumber: string | undefined;
  };
};

export const customerProfile = new Dispatcher<Profile>(
  typeof window === 'undefined' || process.env.NODE_ENV === 'test'
    ? undefined
    : () => {
        if (typeof window === 'undefined') return Promise.reject();
        if (
          window.hyphen == null ||
          window.hyphen?.context.config.auth.endpoint
        ) {
          const cookies = getCookies();
          if (cookies.id_token) {
            try {
              const claims = parseIdentityToken(cookies.id_token);
              return Promise.resolve({
                loggedIn: true,
                customer: {
                  firstName: claims.given_name,
                  email: claims.email,
                  phoneNumber: undefined,
                },
              });
            } catch (e) {
              return Promise.resolve({ loggedIn: true });
            }
          }
          return Promise.resolve({ loggedIn: false });
        }

        // Check refapp session
        return fetchClientOperation(CustomerProfileQueryOperation, {
          language: window.hyphen.locale,
        })
          .next()
          .then((response) => {
            const profile = response.value.data?.customerProfile;
            return {
              loggedIn: profile?.loginState === 'LOGGED_IN',
              customer: profile?.customer
                ? {
                    firstName: profile.customer.firstName,
                    email: profile.customer.email,
                    phoneNumber: profile.customer.phoneNumber?.phoneNumber,
                  }
                : undefined,
            };
          });
      },
);

if (
  typeof window !== 'undefined' &&
  window.hyphen?.context.config.auth.endpoint
) {
  // Update the profile information if we detect the cookie has changed.
  let current: string | undefined = undefined;
  setInterval(() => {
    const cookies = getCookies();
    if (current !== cookies.id_token) {
      current = cookies.id_token;
      customerProfile.forceUpdate();
    }
  }, 1000);
}

export function useCustomerProfile(): Dispatch<Profile> {
  return useDispatcher(customerProfile);
}
